import React, { useState } from "react";
import { Link } from "react-router-dom";
import DelarRegistrationContactSection from "../../components/DelarInfo/DelarRegistrationContactSection";

const GetReadyForDealerRegistration = () => {
  return (
    <>
      <HeroSection />
      <EntitySection />
      <DelarRegistrationContactSection />
    </>
  );
};

export default GetReadyForDealerRegistration;

const HeroSection = () => {
  const dealerRegistrationSteps = [
    {
      step: 1,
      title: "Create a dealer account",
      description:
        "First, set up access to our marketplace, provide us with some basic information about your business, and create your login information.",
      imageUrl:
        "https://static.chrono24.com/images/default/illustrations/selection.svg",
    },
    {
      step: 2,
      title: "Complete your information",
      description:
        "Before you can start selling, we'll need some personal and business-related documents from you. Together, we'll also determine which tax numbers you need to provide.",
      imageUrl:
        "https://static.chrono24.com/images/default/illustrations/basic-data.svg",
    },
    {
      step: 3,
      title: "Start Your 30-Day Trial",
      description:
        "After we've reviewed and verified your documents, your 30-day trial will begin. Create listings and sell your watches worldwide.",
      imageUrl:
        "https://static.chrono24.com/images/default/illustrations/packaged-safely.svg",
    },
  ];
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-8 md:py-6 sm:py-6 ">
      <h1 className="mb-8 lg:text-4xl md:text-3xl sm:text-2xl">
        Registering as a Dealer on WristLink
      </h1>

      <strong>How to Become a Dealer on WristLink :</strong>

      <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 gap-4 mt-6">
        {dealerRegistrationSteps?.map((step, index) => {
          return (
            <div key={index} className="rounded-lg border p-8">
              <img
                src={step?.imageUrl}
                height={132}
                width={132}
                alt=""
                className="mx-auto"
              />
              <p className="mt-6 mb-4 font-medium">
                {index + 1}. {step?.title}
              </p>
              <p className="text-[14px]">{step?.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

const EntitySection = () => {
  const [activeEntity, setEntity] = useState(1);
  return (
    <section className="max-w-[1200px] mx-auto lg:px-2 md:px-4 sm:px-4 lg:py-16 md:py-14 sm:py-12 border-t">
      <p className="mb-8 text-[13px]">
        Since WristLink is located in Germany, we are subject to EU law. This
        means that we need to collect some data about your company before you
        begin using our marketplace. That way, you can better use your trial
        period to sell your watches.
      </p>

      <strong>
        Please have the following info and documents ready for registration:
      </strong>

      <div className="border-b mt-8 ">
        <button
          className={`px-3 py-2 border-b-2 border-b-primary ${
            activeEntity === 1
              ? " border-b-primary  font-medium"
              : " border-b-white "
          }`}
          onClick={() => setEntity(1)}
        >
          Leagal Entity
        </button>
        <button
          className={` py-2 border-b-2 border-b-primary ${
            activeEntity === 2
              ? " border-b-primary  font-medium"
              : " border-b-white "
          }`}
          onClick={() => setEntity(2)}
        >
          Natural Entity
        </button>
      </div>
      <div>
        {activeEntity === 1 ? (
          <>
            <h3 className="font-medium mb-3 mt-6 ml-3 text-[15px]">
              Legal entity/corporation
            </h3>
            <ul className="list-disc ml-8 text-sm">
              <li>Commercial registration number</li>
              <li>Commercial register excerpt</li>
              <li>Taxpayer ID number</li>
              <li>VAT identification number</li>
              <li>Payment account information</li>
              <li>Proof of address</li>
              <li>Proof of ID</li>
              <li>Articles of incorporation</li>
              <li>WristLink shareholder declaration (Download template)</li>
            </ul>
          </>
        ) : (
          <>
            <h3 className="font-medium mb-3 mt-6 ml-3  text-[15px]">
              Natural person/sole proprietor
            </h3>
            <ul className="list-disc ml-8 text-sm">
              <li>Taxpayer ID number</li>
              <li>VAT identification number</li>
              <li>Payment account information</li>
              <li>Proof of address</li>
              <li>Proof of ID</li>
              <li>Business registration</li>
            </ul>
          </>
        )}

        <div>
          <h3 className="font-medium mb-3 mt-6 ml-3  text-[15px]">
            Further information
          </h3>
          <ul className="ml-3 text-sm">
            <li>DAC7 Data</li>
            <li>VAT information</li>
          </ul>
        </div>
      </div>

      <div className="mt-6 border-y  py-6">
        <p className="ml-3 text-sm">
          {" "}
          We can only register you as a dealer if you meet the following
          requirements:
        </p>
        <ul className="list-disc ml-8 my-2 text-sm">
          <li>
            You have a business or company entered into the commercial register
          </li>
          <li>You have at least 50 watches in your inventory</li>
          <li>50 of your watches are worth at least €2,000 each</li>
        </ul>{" "}
        <p className="ml-3 text-sm">
          Please be aware that we reserve the right to deny registration
          requests.
        </p>
      </div>

      {/* CTA */}
      <div className="flex justify-end items-center w-full my-6">
        <Link
          to={"/dealer-info/registration-info?step=1"}
          className="px-12 py-2.5 rounded bg-secondary text-white"
        >
          Let's Get Started!
        </Link>
      </div>
    </section>
  );
};
